import { Route, Routes } from "react-router-dom";

import { AdminRoutes, AuthRoutes, StudentRoutes } from "./routes";

export const AppRouter = () => {
  return (
    <Routes>

      {/* Login y Registro */}
      <Route path="/*" element={<AuthRoutes />} />

      {/* Cuenta y historial de compra */}
      <Route path="/student/*" element={<StudentRoutes />} />

      <Route path="/admin/*" element={<AdminRoutes />} />

      {/* Ruta por defecto */}
      <Route path="*" element={<AuthRoutes />} />
    </Routes>
  );
};
